import { MessagesModel } from '@/Shared/domain'

export const ApiContractFormErrorFieldAdapter = (errorMessage: MessagesModel): string => {
  switch (errorMessage.value) {
    case 'propietaryContact.contactEmailAddress':
      return 'email'
    case 'propietaryContact.contactPhone':
      return 'phone'
    default:
      return ''
  }
}
